import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=3750d7ba&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=ts&"
export * from "./Accordion.vue?vue&type=script&lang=ts&"
import style0 from "./Accordion.vue?vue&type=style&index=0&id=3750d7ba&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3750d7ba",
  null
  
)

export default component.exports